import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { salesDetailsStore } from '../../store/salesDetailsStore';
import { allOptionsValue } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import CustomLazyPicker from 'src/view/components/Controls/Pickers/CustomLazyPicker/CustomLazyPicker';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types/index';
import SpinLoader from 'src/view/components/Controls/SpinLoader/SpinLoader';
import { ReportsBranchPicker } from 'src/view/screens/ReportsScreen/components/ReportsBranchPicker/ReportsBranchPicker';
import ReportsCalendar from 'src/view/screens/ReportsScreen/components/ReportsCalendar/ReportsCalendar';
import ReportsFranchiseePicker from 'src/view/screens/ReportsScreen/components/ReportsFranchiseePicker/ReportsFranchiseePicker';
import ReportContent from 'src/view/screens/ReportsScreen/containers/ReportContent/ReportContent';
import ReportHeader from 'src/view/screens/ReportsScreen/containers/ReportHeader/ReportHeader';
import { reportsStore } from 'src/view/screens/ReportsScreen/store/reportsStore';
import { appStore } from '~/mobx/appStore';
import { REPORT_TYPE } from '~/view/screens/ReportsScreen/types/reports';

const ComboSales = observer(() => {
  const onSelectItem = (options: IPickerOption[]) => {
    salesDetailsStore.filters.combo = options;
  };

  const buildReport = async () => {
    await salesDetailsStore.fetchComboReport();
  };

  useEffect(() => {
    if (!salesDetailsStore.reports.combo.data) buildReport();
  }, []);

  const onCancel = () => {
    if (salesDetailsStore.cancelReportBuild.combo) salesDetailsStore.cancelReportBuild.combo('Cancelled');
  };

  return (
    <div className="d-flex flex-column full-width flex-grow-1 mt-4">
      <ReportHeader
        onGenerateReport={buildReport}
        onExportReport={salesDetailsStore.onExportComboReport}
        exportLoader={salesDetailsStore.reports.combo.loading}
      >
        <ReportsCalendar startDate={reportsStore.filters.startDate} endDate={reportsStore.filters.endDate} />
        <CustomLazyPicker
          className="mr-2"
          inputClassName="report-header__picker"
          onFetch={salesDetailsStore.fetchComboNames}
          selectedOptions={salesDetailsStore.filters.combo}
          defaultOptions={[{ label: localeStore.t('combo_sales_report_all_combo_dropdown_item_name'), value: allOptionsValue }]}
          onSelect={onSelectItem}
          isSearchable
          isMulti
          emptyListText={localeStore.t('no_results_found')}
          small
          optionsDesc="combo"
        />
        {appStore.isAddonsAvailable.franchise ? <ReportsFranchiseePicker /> : <ReportsBranchPicker />}
      </ReportHeader>
      <ReportContent
        actualReport={salesDetailsStore.reports.combo.data}
        reportColumnName="combo_sales_report_combo_column_name"
        disabledRevenue
        reportType={REPORT_TYPE.COMBO}
        className={'row-six-columns'}
      />
      {salesDetailsStore.reports.combo.loading ? <SpinLoader onCancel={onCancel} /> : null}
    </div>
  );
});

export default ComboSales;
